import React, { Component } from "react";
import moment from 'moment';
import _ from 'lodash';
import { Table, Button } from 'semantic-ui-react';
import ReactTable from "react-table";

import "../css/globalStyle.css";

class TxHistoryList extends Component {
	constructor(props){
		super(props);
		this.state = {
			txTimestamp: [],
			txBlockHash: [],
			txBlockNumber: [],
			txHash: [],
			txDetails: [],
			tx:[],
		};
	}

	componentDidMount () {
		// 0xbEC680849704ef821d3319147d60ac8E6057b23E 1st contract
		// 0x39f7d891066dA2aE46f65a4D357983d07Aa45b39 2nd contract
		fetch('https://api-ropsten.etherscan.io/api?module=account&action=txlist&address=0x39f7d891066dA2aE46f65a4D357983d07Aa45b39&startblock=0&endblock=99999999&page=1&offset=50&sort=asc&apikey=2BNZ1TCWG869CE3B9G946GKRNQRAWYVP27')
		.then(response => response.json())
			.then(data => this.setState({ tx: data.result }));
	}

	// getTxHistory = async () => {
  //   const { web3 } = this.props;

  //   const latestBlock = await web3.eth.getBlockNumber();
  //   const newBlocks = [];
	// 	const timeStamps = [];

  //   for (let i = 0; i < latestBlock; i++) {
  //     let blocks = await web3.eth.getBlock(latestBlock - i);
  //     newBlocks.push(blocks);
	// 	}
	// 	console.log(newBlocks)

  //   const txInfo = _.map(newBlocks, _.partialRight(_.pick, ['timeStamp', 'blockHash', 'blockNumber', 'transactions']));
  //   const unixTime = _.map(newBlocks, 'timeStamp');
	// 	// const blockNumberArray = _.map(newBlocks, 'number');

  //   for (let x = 0; x < unixTime.length; x++) {
  //     const formatTime = moment(unixTime[x] * 1000).format("MMM D YYYY, h:mma");
	// 		timeStamps.push(formatTime);
	// 	}

	// 	const txHistory = _.zipWith(txInfo, timeStamps);

  //   this.setState({
	// 		txTimestamp: timeStamps,
	// 		txDetails: txInfo,
	// 		// txBlockHash: blockHashArray,
	// 		// txBlockNumber: blockNumberArray,
	// 	})

	// 	// console.log(txHistory)
	// 	// console.log(timeStamps)
	// }

	getTx = async() => {
		const { tx, txTimestamp } = this.state;

			const timeStamps = [];

			const txInfo = _.map(tx, _.partialRight(_.pick, ['timeStamp', 'blockHash', 'blockNumber', 'hash', 'gasUsed']));
			const unixTime = _.map(tx, 'timeStamp');

			try {
			// 0xbEC680849704ef821d3319147d60ac8E6057b23E
			await fetch('https://api-ropsten.etherscan.io/api?module=account&action=txlist&address=0x39f7d891066dA2aE46f65a4D357983d07Aa45b39&startblock=0&endblock=99999999&page=1&offset=50&sort=asc&apikey=2BNZ1TCWG869CE3B9G946GKRNQRAWYVP27')
			.then(response => response.json())
				.then(data => this.setState({ tx: data.result }));

			for (let x = 0; x < unixTime.length; x++) {
				const formatTime = moment(unixTime[x] * 1000).format("MMM D YYYY, h:mma");
				timeStamps.push(formatTime);
			}

			this.setState({
				txTimestamp: timeStamps,
				txDetails: txInfo,
				// txBlockHash: blockHashArray,
				// txBlockNumber: blockNumberArray,
			})

			console.log(tx);
			console.log(txInfo);
			console.log(timeStamps);
		}catch(err){
			alert(err);
		}
	}


	render() {
		const { txTimestamp, txBlockHash, txBlockNumber, txDetails } = this.state;

		return(
			<div>
					<button onClick={this.getTx} class="btn" style={{ marginBottom: 12 }}>
						<span>Transaction History</span>
					</button>
					<div style={{ marginBottom: 6 }}>OR</div>
					<a href='https://ropsten.etherscan.io/address/0x39f7d891066da2ae46f65a4d357983d07aa45b39' rel="noopener noreferrer" target="_blank">Etherscan.io</a>

						<table id="receipt" class="center">
							<thead>
								<tr>
									<th>Block Number</th>
									<th>Block Hash</th>
									<th>Transaction Hash</th>
                  {/* <th>Gas Used</th> */}
									<th>Timestamp</th>
								</tr>
							</thead>

							<tbody>
							{txDetails.map((tx, index) => (
								<tr key={index}>
									<td>{tx.blockNumber}</td>
									<td>{tx.blockHash}</td>
									<td>{tx.hash}</td>
                  {/* <td>{tx.gasUsed}</td> */}
									<td>{moment(tx.timeStamp * 1000).format("MMM D YYYY, h:mma")}</td>
								</tr>
									))}
							</tbody>
						</table>
			</div>
		)
	}
}

export default TxHistoryList;
